export const MARKDOWN_EDITOR_ROUTE = '/files/markdown-editor';

export function buildMarkdownEditorSearch(mountId: string, relativePath: string): string {
  const params = new URLSearchParams();
  params.set('mountId', mountId);
  params.set('path', relativePath);
  return params.toString();
}

export function markdownEditorHref(mountId: string, relativePath: string): string {
  return `${MARKDOWN_EDITOR_ROUTE}?${buildMarkdownEditorSearch(mountId, relativePath)}`;
}
